<template>
  <div>
    <b-card-actions
      ref="cardAction"
      title="Banka Bilgileri"
      icon="BriefcaseIcon"
      :showLoading="show"
      :actionCollapse="false"
      :actionRefresh="true"
      :actionNewAdd="true"
      :collapsed="false"
      @refresh="refreshStop('cardAction')"
      @newAdd="handlerNewAdd($event)"
    >
      <!-- actionCollapse true ise filtre kısmı calısırız -->
      <template v-slot:body>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :line-numbers="false"
          :search-options="{
            enabled: false,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
          styleClass="vgt-table striped bordered"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'banka_adi'">
              {{ props.row.banka_adi }}
            </span>
            <span v-else-if="props.column.field === 'banka_iban'">
              {{ props.row.banka_iban }}
            </span>
            <span v-else-if="props.column.field === 'action'" class="float-right px-1">
              <b-button-group size="sm" class="pb-25">
                <b-button class="rounded-0" variant="warning" @click="handlerUpdate(props.row)">
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button variant="danger" class="rounded-0" @click="handlerRemove(props.row.k_no)">
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </b-button-group>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <v-select
                  v-model="pageLength"
                  :options="perPageOptions"
                  :clearable="false"
                  class="invoice-filter-select"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </template>
    </b-card-actions>
    <banka-tanimla
      :openModal="openModal"
      :updateData="updateData"
      @updateToValue="handlerGetData"
      @closeModal="closeModal = $event"
    ></banka-tanimla>
  </div>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue';
import { VueGoodTable } from 'vue-good-table';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { mapGetters } from 'vuex';
import BankaTanimla from './bankaTanimla.vue';
export default {
  components: {
    BCardActions,
    VueGoodTable,
    vSelect,
    BankaTanimla,
  },
  data() {
    return {
      show: false,
      openModal: false,
      closeModal: false,
      updateData: {},
      pageLength: 10,
      perPageOptions: [10, 25, 50, 100],
      columns: [
        {
          label: 'Banka Adı',
          field: 'banka_adi',
        },
        {
          label: 'İban',
          field: 'banka_iban',
        },
        {
          label: 'Hesap Turu',
          field: 'banka_hesap_turu',
          // thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          label: 'İşlemler',
          field: 'action',
          width: '10%',
        },
      ],
      searchTerm: null,
      rows: [],
    };
  },
  computed: {
    ...mapGetters(['getOdemeBankaBilgi']),
  },
  created() {
    this.handlerGetData();
  },
  methods: {
    handlerNewAdd(event) {
      this.openModal = true;
    },
    async handlerGetData() {
      this.show = true;
      await this.$store.dispatch('odemeBankaBilgiListele');
      this.rows = await this.getOdemeBankaBilgi;
      this.show = false;
    },

    refreshStop(event) {
      this.handlerGetData();
    },
    handlerUpdate(event) {
      this.openModal = true;
      this.updateData = event;
    },
    handlerRemove(k_no) {
      this.$swal({
        title: 'Uyarı',
        text: 'Kayit Silinecektir',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır',
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.$store.dispatch('odemeBankaBilgiSil', k_no).then((res) => {
            if (res.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Silme`,
                  icon: 'Trash2Icon',
                  variant: 'danger',
                  text: `Silme başarılı.`,
                },
              });
              this.handlerGetData();
            }
          });
        }
      });
    },
  },
  watch: {
    async closeModal(val) {
      if (val == false) {
        this.openModal = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
table.vgt-table {
  font-size: 14px;
  thead {
    background-color: rgba($black, 0.07);
  }
  td {
    padding: 3px 0px 0px 5px !important;
    vertical-align: middle !important;
  }
}
</style>
